import React, { memo, useContext } from 'react'
import { Modal, Typography } from '..'
import { LanguageContext } from '../../../context/LanguageContext'

const GenericConfirmationModal = ({ show, title, contentText, onCancelClick, onSaveClick }) => {
    const { strings } = useContext(LanguageContext)

    if (!show) {
        return null
    }
    const heading = <Modal.Heading heading={title} cancelModalHandler={onCancelClick} />

    const content = <Typography className={'mt-4'} text={contentText} />

    const actions = (
        <Modal.Actions
            cancelModalHandler={onCancelClick}
            saveClickHandler={onSaveClick}
            submitBtn={strings.CONFIRMATION_SUBMIT}
            cancelBtn={strings.CONFIRMATION_CANCEL}
            color={'primary'}
            size={'xl'}
        />
    )

    return <Modal header={heading} content={content} actions={actions} size={'sm'} />
}

export default memo(GenericConfirmationModal)
